import React, { useState, useEffect } from "react";
import ReactFlow, { Background } from "reactflow";
import "reactflow/dist/style.css";

export const DebtGraph = ({ nodes, edges }) => {
  return (
    <div style={{ width: "100%", height: 600 }}>
      <style>{`.react-flow__panel.react-flow__attribution.bottom.right { display: none}`}</style>
      <ReactFlow
        nodes={nodes}
        edges={edges}
        fitView={true}
        panOnScroll={false}
        panOnDrag={false}
        zoomOnPinch={false}
        zoomOnScroll={false}
      >
        <Background gap={12} />
      </ReactFlow>
    </div>
  );
};
